import {
  AutocompleteRawContext,
  RawProperty,
  autocompleteContext,
} from '@jupiterone/query-language-autocomplete';
import autocompleteApi from '../autocompleteApi';
import { LoadAutocompleteData } from './types';
import withDefault from './withDefault';

const load = async (
  inputData: LoadAutocompleteData
): Promise<AutocompleteRawContext> => {
  const { accountId, expires, client, backing } = withDefault(inputData);

  const [counts, properties] = await Promise.all([
    autocompleteApi.entityCounts(client),
    [] as RawProperty[],
  ]);

  const context = autocompleteContext.createRaw(counts, properties);
  backing.setItem(context, expires, accountId);
  return context;
};

export default load;
